// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","container":"container-292aB","wrapper":"wrapper-3fn9X","linkWithIcon":"linkWithIcon-zaZ0j","promoCode":"promoCode-228xI"};